"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareCsv = exports.getType = exports.convertResponseData = void 0;
var _react = _interopRequireDefault(require("react"));
var _server = _interopRequireDefault(require("react-dom/server"));
var _flat = _interopRequireDefault(require("flat"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isInteger2 = _interopRequireDefault(require("lodash/isInteger"));
var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var convertResponseData = exports.convertResponseData = function convertResponseData(data) {
  var errorMessage = "Response must contain data in this format:\n{\n    someKeyWithArrayData: [],\n    totalCount: NNN,\n    filteredCount: NNN,\n}";
  var flatten = function flatten(obj) {
    return (0, _flat["default"])(obj, {
      safe: true
    });
  };
  var flattenData = flatten(data);
  var nodesKey = Object.keys(flattenData).find(function (key) {
    return /filteredCount$/.test(key);
  });
  if (!nodesKey) {
    throw new Error(errorMessage);
  }
  var path = nodesKey.replace(/\.?filteredCount$/, '');
  var item = path ? (0, _get2["default"])(data, path) : data;
  var arrayKeys = Object.keys(item).filter(function (key) {
    return (0, _isArray2["default"])(item[key]);
  });
  if (arrayKeys.length !== 1) {
    throw new Error(errorMessage);
  }
  var dataKey = arrayKeys[0];
  if (!(0, _isArray2["default"])(item[dataKey]) || !Number.isInteger(item.totalCount) || !Number.isInteger(item.filteredCount)) {
    throw new Error(errorMessage);
  }
  var isData = function isData(value, key) {
    return !/__typename$/.test(key);
  };
  var getExtraData = function getExtraData() {
    var extraDataAlongsidePath = (0, _pickBy2["default"])(flatten((0, _omit2["default"])(item, [dataKey, 'totalCount', 'filteredCount'])), isData);
    var extraDataOutsidePath = (0, _pickBy2["default"])(flatten((0, _omit2["default"])(data, [path])), isData);
    return path ? _objectSpread(_objectSpread({}, extraDataAlongsidePath), extraDataOutsidePath) : extraDataAlongsidePath;
  };
  return {
    dataPath: path ? "".concat(path, ".").concat(dataKey) : dataKey,
    data: item[dataKey].map(function (obj) {
      return (0, _pickBy2["default"])(flatten(obj), isData);
    }),
    extraData: getExtraData(),
    totalCount: item.totalCount,
    filteredCount: item.filteredCount
  };
};
var getType = exports.getType = function getType(value) {
  var type = _typeof(value);
  if (type === 'string' || type === 'boolean') {
    return type;
  }
  if ((0, _isInteger2["default"])(value)) {
    return 'int';
  }
  if (type === 'number') {
    return 'float';
  }
  return 'unknown';
};
var prepareCsv = exports.prepareCsv = function prepareCsv(value) {
  if (!value && value !== 0) {
    return '';
  }
  var stringValue = '';
  try {
    stringValue = /*#__PURE__*/_react["default"].isValidElement(value) ? _server["default"].renderToStaticMarkup(value) : String(value);
  } catch (error) {
    return '';
  }

  // strip HTML tags
  stringValue = stringValue.replace(/(<([^>]+)>)/gi, '');
  return /^[A-Za-z0-9._-]+$/.test(stringValue) ? stringValue : '"' + stringValue.replace(/"/g, '""') + '"';
};